import React, { useState, useContext, useCallback, useRef } from 'react';
import FormInput from '../../../../widgets/form/components/form-input/FormInput/FormInput';
import UserContext, { UserProfileContext } from '../../../../common/utils/getContext';
import StoreSearchItem from './StoreSearchItem/StoreSearchItem';
import { navigateV2, getData } from '../../../../common/utils/router';
import T, { t } from '../../../../common/components/T';
import { LangContext } from '../../../../common/decorators/Language';
import css from './store-search.module.scss';
import { Img, svgSprite } from '../../../../hybrid/wrappers';

const StoreSearch = ({ qSearch, afterOpenedFunc, afterClosedFunc }) => {
    const { userToken, lang, loadedProfile, localization } = useContext(UserContext);
    const { profileData } = useContext(UserProfileContext);
    const { translation } = useContext(LangContext);
    const routePage = 'shop/products?include=media,properties';
    const [isOpenedInput, setIsOpenedInput] = useState(false);

    const [search, setSearch] = useState(false);
    const [q, setQ] = useState(qSearch);
    const [searchDB, setSearchDB] = useState([]);

    const timeout = useRef(null);
    const searchGlobalFunc = useCallback(
        (text) => {
            clearTimeout(timeout.current);
            setQ(text);
            if (text && loadedProfile) {
                setSearch(true);
                timeout.current = setTimeout(async () => {
                    let getParams = `&filter[q]=${text}`;
                    const currency = profileData?.currency?.code || localization?.currency;
                    if (profileData?.country?.geoname_id) {
                        getParams += `&filter[country_id]=${profileData?.country?.geoname_id}`;
                    }
                    const searchData = await getData(`/api/v1/${routePage}${getParams}`, userToken, lang, false, currency);
                    if (searchData) {
                        setSearchDB(searchData.data);
                    }
                }, 500);
            } else {
                setSearch(false);
                setSearchDB([]);
            }
        },
        [timeout, userToken, lang, loadedProfile, profileData, localization?.currency]
    );

    const compStyle = {
        wrapper: css.wrapperSearch,
        input: css.inputSearch,
        // inputFocus: css.inputSearch,
        placeholder: css.inputSearchPlaceholder,
        icon: {
            className: css.inputSearchIcon
        },
        close: {
            icon: {
                className: css.inputCloseIcon
            }
        },
        inner: {
            className: css.inputSearchInner
        },
        formControlContentAddon: css.formControlContentAddon
    };

    const openInputFunc = () => {
        setIsOpenedInput(true);
        afterOpenedFunc && afterOpenedFunc();
    };

    const closeInputFunc = () => {
        setSearch(false);
        setIsOpenedInput(false);
        afterClosedFunc && afterClosedFunc();
    };

    const config = {
        attribute: 'product',
        type: 'input',
        search: { type: 'onInput', icon: 'search-gt' },
        placeholder: t('storeSearchPhrase-v1', 'Что будем искать?', '/store', translation),
        handlers: {
            onChange: (v) => {
                searchGlobalFunc(v);
            },
            onKeyPress: (e) => {
                if (e.target.value.length > 0) {
                    return navigateV2(`/store/search?q=${encodeURI(e.target.value)}`);
                }
            }
        },
        compStyle,
        value: q,
        buttons: {
            close: {
                icon: 'cross',
                handler: closeInputFunc
            }
        }
    };

    // useEffect(() => {
    //     if (search) {
    //         document.body.style.height = 'calc(100% - 48px)';
    //         document.body.style.overflow = 'hidden';
    //     } else {
    //         document.body.style.height = 'auto';
    //         document.body.style.overflow = 'initial';
    //     }
    // }, [search]);

    return (
        <div className={css.storeSearch}>
            {isOpenedInput ? null : (
                <div onClick={() => openInputFunc()} className={css.storeSearchIcon}>
                    {svgSprite('search-gt')}
                </div>
            )}
            {isOpenedInput ? <FormInput {...config} /> : null}
            {/* {!screenWidth && (
                <div
                    className={css.buttonPrimarySearch}
                    onClick={() => {
                        if (q) {
                            navigateV2(`/store/search?q=${encodeURI(q || '')}`);
                        }
                    }}
                >
                    <T textName='store-Search' defaultStr='Найти' page='/store' />
                </div>
            )} */}
            {search && (
                <div
                    className={css.fieldSearch}
                    // onMouseLeave={() => setSearch(false)}
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                >
                    <p className={css.fieldSearchTitle}>
                        <T
                            vars={{ products: searchDB?.length || 0 }}
                            textName='storeResultTitle'
                            defaultStr='Найдено товаров (${products})'
                            page='/store'
                        />
                    </p>
                    {searchDB && searchDB.length > 0 ? (
                        searchDB.map((elem, idx) => <StoreSearchItem item={elem} key={`search${idx}`} />)
                    ) : (
                        <div className={css.searchItemNo}>
                            <Img src='/src/img/plugs/store_no_products.svg' alt='No products' className={css.searchItemNoImg} />
                            <p className={css.searchItemNoTitle}>
                                <T textName='product-not-found' defaultStr='Товар не найден' page='/store' />
                            </p>
                            <p className={css.searchItemNoText}>
                                <T
                                    textName='storeNoResult-v1'
                                    defaultStr='По вашему запросу не найдено ни одного товара. Попробуйте изменить условия поиска'
                                    page='/store'
                                />
                            </p>
                        </div>
                    )}
                </div>
            )}
            {search && (
                <div
                    className={css.fieldSearchBackground}
                    onClick={() => {
                        setSearch(false);
                    }}
                ></div>
            )}
        </div>
    );
};
export default StoreSearch;
